<div id="register-info" class="form-container">
    <div class="row">
        <div class="col-md-12 text-center">
          <h4>Additional Action Required</h4><br><br>
          <p>We are unable to process your cancellation at this time. <br><br>Please call our dedicated resident services center at 855.676.1680. Thank you.
          </p>
        </div>
      </div> 
</div>